
import axios from 'axios';
import config from '../config.json'
import konsole from "./konsole";
import AoUrl, { AoLoginUrl } from './url';
import { BASE_URL, stripePaymentConfirmationUrl, BASE_URL_New } from './url';
import { Authtoken } from '../control/Constant';
import { applyAuditFields } from './auditFields';
import { encryptPayload, decryptPayload, encryptGetUrl, decryptGetUrl, fileToBase64 } from '../Component/Crypto/aseGCM';

axios.defaults.baseURL = BASE_URL;
const isEncryptionEnabled = String(process.env.REACT_APP_IS_ENCRYPTION_ENABLED).trim().toLowerCase() === "true";

let $CommonServiceFn = {



  InvokeCommonApi: async function (method, url, inputdata, callback) {

    const token = sessionStorage.getItem("AuthToken");
    const requestMethod = method?.toUpperCase();

    let requestUrl = url;
    inputdata = applyAuditFields(requestMethod, url, inputdata); // createdBy / updatedBy = logged-in user
    let requestData = inputdata;
    const isFileUpload = inputdata instanceof FormData;

    try {

      // ============================================================
      // GET
      // ============================================================

      if (requestMethod == "GET") {

        if (!/^https?:\/\//i.test(requestUrl)) {
          requestUrl = `${BASE_URL.replace(/\/$/, "")}/${requestUrl.replace(/^\//, "")}`;
        }

        if (inputdata && !Array.isArray(inputdata) && typeof inputdata === "object" && Object.keys(inputdata).length > 0) {

          const urlObj = new URL(requestUrl);
          Object.entries(inputdata).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
              urlObj.searchParams.set(key, String(value));
            }

          });

          requestUrl = urlObj.toString();
        }

        // GET URL encryption only when enabled
        if (isEncryptionEnabled === true) {
          requestUrl = await encryptGetUrl(requestUrl);
        }

        requestData = null;
      }

      else if (inputdata instanceof FormData) {
        requestData = inputdata;
      }

      // ============================================================
      // NORMAL JSON API
      // ============================================================

      else if (inputdata !== undefined && inputdata !== null) {
        if (isEncryptionEnabled === true) {
          requestData = await encryptPayload(inputdata);
        } else {
          requestData = inputdata;
        }
      }

      // ============================================================
      // EMPTY BODY
      // ============================================================

      else {
        requestData = inputdata;
      }


      // ============================================================
      // AXIOS REQUEST
      // ============================================================

      const response = await axios({

        headers: {
          "Access-Control-Allow-Origin": true,
          "Authorization": `Bearer ${token}`
        },

        method: requestMethod,
        url: requestUrl,
        data: requestData
      });

      // ============================================================
      // RESPONSE
      // FILE RESPONSE NEVER DECRYPT
      // ============================================================


      if (!isFileUpload && isEncryptionEnabled === true && response?.data?.encrypted === true) {

        response.data = await decryptPayload(response.data);

      }

      if (callback) {
        callback(response, null);
      }

      return response;

    } catch (error) {

      const errordata = error?.response || null;

      if (errordata) {

        if (errordata.status === 401) {

          sessionStorage.setItem("AuthToken", "");
          window.location.replace(AoLoginUrl);
          if (callback) {
            callback(null, {
              ...errordata,
              isApiError: true
            });
          }

          return null;
        }

        if (callback) {
          callback(null, {
            ...errordata,
            isApiError: true
          });
        }

        return null;

      } else {

        if (callback) {
          callback(null, {
            status: 500,
            isApiError: true,
            data: {
              message:
                error?.message ||
                "Something went wrong"
            }
          });
        }

        return null;
      }
    }
  },

  InvokeContractApi: function (method, url, inputdata, callback) {

    axios({
      method: method,
      url: url,
      data: (inputdata !== null) ? inputdata : null
    })

      .then(data => {
        konsole.log("URL-", url)

        if (callback) {
          callback(data, null);
        }
      })

      .catch(error => {
        let errordata = null;

        konsole.log("Error ", error + url)
        konsole.log("Error ", error.response)

        if (error.response) {
          errordata = error.response;

          if (errordata.status == 401) {
            let newWin = window.open(
              `${AoUrl}/ContractExpressAuth`,
              'height=200,width=150'
            );

            if (!newWin || newWin.closed || typeof newWin.closed == "undefined") {
              alert("please disable popup blocker to proceed.");
            }

            callback(null, errordata);
          }

          if (errordata.status !== 401 && errordata.status == 404) {
            if (callback) {
              callback(null, errordata);
            }
          }

          if (errordata.status !== 401 && errordata.status == 400) {
            if (callback) {
              callback(null, errordata);
            }
          }

          if (errordata.status !== 401 && errordata.status == 503) {
            konsole.log("Something went Wrong. Try again later.");
          }

          if (errordata.status !== 401 && errordata.status == 500) {
            callback(null, errordata);
          }
        }

      });

  },


  InvokeFileApi: function (method, url, inputdata, callback) {

    let token = sessionStorage.getItem("AuthToken")

    axios({
      headers: {
        'Access-Control-Allow-Origin': true,
        "Authorization": `Bearer ${token}`
      },
      method: method,
      url: url,
      data: inputdata
    })

      .then(data => {
        if (callback) {
          callback(data, null);
        }
      })

      .catch(error => {
        let errordata = null;

        konsole.log("Error ", error + url)
        konsole.log("Error ", error?.response)

        if (error.response) {
          errordata = error?.response;

          if (errordata?.status == 400) {

            if (errordata?.data?.messages) {
              callback(null, errordata?.data?.messages[0])
            }

            if (errordata?.data?.errors) {
              callback(null, errordata)
            }
          }

          if (errordata.status == 401) {
            sessionStorage.setItem("AuthToken", "");
          }

          if (
            errordata?.status !== 401 &&
            errordata?.status == 404 ||
            errordata?.status == 413
          ) {
            if (callback) {
              callback(null, errordata);
            }
          }
        }

      });

  },


  InvokeCommonSocialInviterApi: function (
    method,
    url,
    inputdata,
    header,
    callback
  ) {

    let token = sessionStorage.getItem("AuthToken")

    axios({
      headers: {
        'Access-Control-Allow-Origin': true,
        "Authorization": `Bearer ${token}`,
        ...header
      },
      config: {
        headers: header
      },
      method: method,
      url: url,
      data: inputdata
    })

      .then(data => {
        if (callback) {
          konsole.log("URL-", url, data);
          callback(data, null);
        }
      })

      .catch(error => {
        let errordata = null;

        konsole.log("Error ", error + url)
        konsole.log("Error ", error.response)

        if (error.response) {
          errordata = error.response;

          if (errordata.status == 401) {
            sessionStorage.setItem("AuthToken", "");
          }

          if (errordata.status !== 401 && errordata.status == 404) {
            if (callback) {
              return callback(null, errordata);
            }
          }

          if (errordata.status !== 401 && errordata.status == 400) {
            if (callback) {
              return callback(null, errordata);
            }
          }

          if (errordata.status !== 401 && errordata.status == 503) {
            konsole.log("Something went Wrong. Try again later.");
          }

          if (callback) {
            return callback(null, errordata);
          }
        }
      });
  },
}

const invoke = async (url, method, body, cancel) => {

  if (cancel) {
    cancel();
  }

  try {

    const token = sessionStorage.getItem("AuthToken");

    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    const requestMethod = method?.toUpperCase();
    let requestUrl = url;
    let requestData = null;
    body = applyAuditFields(requestMethod, url, body); // createdBy / updatedBy = logged-in user
    // FILE UPLOAD CHECK
    const isFileUpload = body instanceof FormData;


    if (requestMethod === "GET") {

      if (!/^https?:\/\//i.test(requestUrl)) {
        requestUrl = `${BASE_URL.replace(/\/$/, "")}/${requestUrl.replace(/^\//, "")}`;
      }

      if (
        body &&
        !Array.isArray(body) &&
        typeof body === "object" &&
        Object.keys(body).length > 0
      ) {

        const urlObj = new URL(requestUrl);

        Object.entries(body).forEach(([key, value]) => {

          if (
            value !== undefined &&
            value !== null
          ) {

            urlObj.searchParams.set(
              key,
              String(value)
            );
          }

        });

        requestUrl = urlObj.toString();
      }

      // GET URL encrypt only when enabled
      if (isEncryptionEnabled === true) {
        requestUrl = await encryptGetUrl(requestUrl);
      }

      requestData = null;
    }


    else {


      if (body instanceof FormData) {
        requestData = body;
      }

      // ==========================================================
      // NORMAL JSON API
      // ==========================================================

      else if (
        body !== undefined &&
        body !== null
      ) {

        if (isEncryptionEnabled === true) {
          requestData = await encryptPayload(body);
        } else {
          requestData = body;
        }
      }


      else {
        requestData = body;
      }
    }


    const response = await axios({

      cancelToken: new axios.CancelToken(
        function executor(c) {
          cancel = c;
        }
      ),

      method: requestMethod,

      url: requestUrl,

      params: null,

      data: requestData
    });


    if (
      !isFileUpload &&
      isEncryptionEnabled === true &&
      response?.data?.encrypted === true
    ) {

      response.data = await decryptPayload(response.data);
    }

    return response;
  } catch (error) {

    if (axios.isCancel(error)) {
      return null;
    }

    return {
      ...(error?.response || {}),
      isApiError: true,
      status: error?.response?.status || 500,
      data: error?.response?.data || {
        message:
          error?.message ||
          "Something went wrong"
      }
    };
  }
};


const Services = {

  getUserSubscription: async (subtenantId, subscriptionId, userId) => {
    let cancel;
    let url = AoUrl.getUserSubscription + `${subtenantId}/${true}?SubscriptionId=${subscriptionId}&UserId=${userId}`;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  addUserSubscription: async (json) => {
    let cancel;
    let url = AoUrl.addUserSubscription;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  updateUserSubscription: async (json) => {
    let cancel;
    let url = AoUrl.updateUserSubscription;
    let body = json;
    return invoke(url, "PUT", body, cancel);
  },

  getSubscriptionDetails: async (subtenantId, subscriptionId) => {
    let cancel;
    let url = AoUrl.getSubscriptionDetails + `${subtenantId}/${subscriptionId}`;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  getUserSubscriptionPlansAsync: async (userSubscriptionId, isActive = true) => {
    let cancel;
    let url = AoUrl.getUserSubscriptionPlansAsync + `?UserSubscriptionId=${userSubscriptionId}&IsActive=${isActive}`;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  upsertUserSubscriptionPlans: async (json) => {
    let cancel;
    let url = AoUrl.upsertUserSubscriptionPlans;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  getUserByEmail: async (email) => {
    let cancel;
    let url = AoUrl.getUserListByEmailId;
    let body = {};
    body['emailId'] = email;
    return invoke(url, "GET", body, cancel);
  },

  getUserByName: async (json) => {
    let cancel;
    let url = AoUrl.get_UserbyName;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  GetClientARDetailsByUserId: async (json, id) => {
    let cancel;
    let url = AoUrl.GetClientARDetailsByUserId + "/" + id;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  CreateModifySubsRequest: async (json) => {
    let cancel;
    let url = AoUrl.CreateModifySubsRequest;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  GetModifySubsRequest: async (json) => {
    let cancel;
    let url = AoUrl.GetModifySubsRequest;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  GetClientBySubtenantId: async (json) => {
    let cancel;
    let url = AoUrl.GetClientBySubtenantId;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  getUserServices: async (id) => {
    let cancel;
    let url = AoUrl.getUserServices + id;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  getUserAuthSubs: async (subtenantId, id) => {
    let cancel;
    let url = AoUrl.getuserSubs + `${subtenantId}?UserId=${id}&PageNumber=${1}&RowsOfPage=${50}`;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  addNewUserdataservice: async (jsonObj) => {
    let cancel;
    let url = AoUrl.addNewUserdata;
    let body = jsonObj;
    return invoke(url, "POST", body, cancel);
  },

  getContact: async (userId) => {
    let cancel;
    let url = AoUrl.getContactByUserId + userId;
    return invoke(url, "GET", null, cancel);
  },

  updateContact: async (userId, jsonObj) => {
    let cancel;
    const url = AoUrl.updateContactByUserId + userId;
    return invoke(url, "PUT", jsonObj, cancel);
  },

  UpdateModifySubsRequest: async (jsonObj) => {
    let cancel;
    const url = AoUrl.UpdateModifySubsRequest;
    return invoke(url, "PUT", jsonObj, cancel);
  },

  getMemberDetails: async (userId) => {
    let cancel;
    let url = AoUrl.getMemberDetails + userId;
    return invoke(url, "GET", null, cancel);
  },

  postAddUserOrderservice: async (jsonObj) => {
    let cancel;
    let url = AoUrl.postAddUserOrder;
    let body = jsonObj;
    return invoke(url, "POST", body, cancel);
  },

  postconfirmUserOrderservice: async (jsonObj) => {
    let cancel;
    let url = AoUrl.confirmUserOrder;
    let body = jsonObj;
    return invoke(url, "POST", body, cancel);
  },

  getUserListByRoleIdservice: async (jsonObj) => {
    let cancel;
    let url = AoUrl.getUserListByRoleId;
    let body = jsonObj;
    return invoke(url, "POST", body, cancel);
  },

  getCommonApi: async (method, urls, json) => {
    let cancel;
    let url = urls;
    let body = json;
    return invoke(url, method, body, cancel);
  },

  getUserRolesByUserId: async (loggedInUserId) => {
    let cancel;
    let url = AoUrl.getUserDetailByEmailId + 'UserId=' + loggedInUserId;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  getSubscriptionBysubtenant: async (subtenantId) => {
    let cancel;
    let url = AoUrl.getUserServices + subtenantId;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  upserUserAuthSubs: async (jsonObj) => {
    let cancel;
    let url = AoUrl.upserUserAuthSubs;
    return invoke(url, 'POST', jsonObj, cancel)
  },

  upateMemberByuserID: async (jsonObj) => {
    let cancel;
    let url = AoUrl.putUpdateMember;
    return invoke(url, 'PUT', jsonObj, cancel)
  },

  putUpdateMemberEmail: async (jsonObj) => {
    let cancel;
    let url = AoUrl.putUpdateMemberEmail;
    return invoke(url, 'PUT', jsonObj, cancel)
  },

  getTenantslist: async (subtenantId, searchText) => {
    let cancel;
    let url = AoUrl.getTenantslist + subtenantId + "?SearchText=" + searchText;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  upsertTenantdata: async (jsonObj) => {
    let cancel;
    let url = AoUrl.upsertTenantdata;
    return invoke(url, 'POST', jsonObj, cancel)
  },

  getFinancecalculation: async (json) => {
    let cancel;
    let url = AoUrl.getFinancecalculation;
    return invoke(url, 'POST', json, cancel)
  },

  GetClientDetailsByUserId: async (json, id) => {
    let cancel;
    let url = AoUrl.GetClientDetailsByUserId + id;
    return invoke(url, 'POST', json, cancel)
  },

  getUserLegalStaff: async (primaryUserId) => {
    let cancel;
    let url = AoUrl.getUserLegalStaff + '?PrimaryUserId=' + primaryUserId;
    return invoke(url, 'GET', '', cancel)
  },
  getFeedbackPriority: async () => {
    let cancel;
    let url = AoUrl.GetFeedbackPriority
    let body = {};
    // body[''] = subtenantId;

    return invoke(url, "GET", body, cancel);
  },
  postFileUpload: function (file, userId, loggedInUser, fileTypeId, fileCategoryId, fileStatusId, callback, userfileName) {
    let formdata = new FormData();
    formdata.append('file', file)
    formdata.append('UserId', userId)
    formdata.append('UploadedBy', loggedInUser)
    formdata.append('FileTypeId', fileTypeId)
    formdata.append('FileCategoryId', fileCategoryId);
    formdata.append('FileStatusId', fileStatusId)
    if (userfileName) {
      formdata.append('UserFileName', userfileName)
    }
    let cancel;
    const url = BASE_URL_New + '/api/FileUpload/uploadUserDocuments'
    // let url = AoUrl.fileUploadPath
    let body = formdata;
    return invoke(url, 'POST', body, cancel)

  },
  postFeedback: async (json) => {
    let cancel;
    let url = AoUrl.postFeedback
    let body = json;
    return invoke(url, 'POST', body, cancel)
  },
  sendPostEmailCC: async (json) => {
    let cancel;
    let url = AoUrl.sendPostEmailCC
    let body = json;
    return invoke(url, 'POST', body, cancel)
  },
  sendMailFeedBack: async (json) => {
    let cancel;
    let url = AoUrl.sendMailFeedBack
    let body = json;
    return invoke(url, 'POST', body, cancel)
  },

  upsertUserLegalStaff: async (json) => {
    let cancel;
    let url = AoUrl.upsertUserLegalStaff;
    return invoke(url, 'POST', json, cancel)
  },

  getUserProfileDetailsService: async (primaryUserId) => {
    let cancel;
    let url = AoUrl.get_UserProfileDetailsByUserId + primaryUserId;
    return invoke(url, 'GET', '', cancel)
  },

  postCardVerifyService: async (jsonObj) => {
    let cancel;
    let url = AoUrl.postCardVerify;
    return invoke(url, 'POST', jsonObj, cancel)
  },

  postSyncUserCardInfoService: async (jsonObj) => {
    let cancel;
    let url = AoUrl.postSyncUserCardInfo;
    return invoke(url, 'POST', jsonObj, cancel)
  },

  postApiCallNew: async (method, url, jsonObj) => {
    // console.log("kjadshfkdjsfhkjdsfhkjds", method, url, jsonObj)
    return new Promise((resolve, reject) => {
      $CommonServiceFn.InvokeCommonApi(method, url, jsonObj, (res, err) => {
        if (res) {
          konsole.log('res of saving', url, res);
          let response = { isError: "false", resPonse: res }
          resolve(response)
        } else {
          konsole.log('res in saving', url, err);
          let response = { isError: "true", resPonse: err }
          resolve(response)
        }
      })
    })
  },

  getGetOrderInfoApi: async (orderId, userId) => {
    let cancel;
    let url = AoUrl.getGetOrderInfo + userId + "/" + orderId;
    return invoke(url, 'GET', '', cancel)
  },

  getUserDetailByEmailId: async (email) => {
    let cancel;
    let url = AoUrl.getUserDetailByEmailId + `emailId=${email}`;
    return invoke(url, 'GET', '', cancel)
  },

  subtenantCreateUser: async (jsonObjData) => {
    let cancel;
    let url = AoUrl.postsubtenantcreateUser;
    let body = jsonObjData;
    return invoke(url, "POST", body, cancel)
  },

  postRoleIdData: async (userId, loginUserId, subtenantId, roleId, isActive, createdBy) => {
    let cancel;
    let url = AoUrl.postRoleIdAPI + userId;
    let body = {}
    body['loginUserId'] = loginUserId;
    body['subtenantId'] = subtenantId;
    body['roleId'] = roleId;
    body['isActive'] = isActive;
    body['createdBy'] = createdBy;
    return invoke(url, "POST", body, cancel)
  },

  putRoleIdDetails: async (loginUserId, subtenantId, roleId, isActive, userRoleId, updatedBy, remarks) => {
    let cancel;
    let url = AoUrl.putRoleIdAPI + updatedBy;
    let body = {}
    body['loginUserId'] = loginUserId;
    body['subtenantId'] = subtenantId;
    body['roleId'] = roleId;
    body['isActive'] = isActive;
    body['userRoleId'] = userRoleId;
    body['updatedBy'] = updatedBy;
    body['remarks'] = remarks;
    return invoke(url, 'PUT', body, cancel)
  },

  postspeakerupsertuser: async (speakerUserId, userId, speakerProfile, videoLinkPath, speakerImageId, remarks, isActive, upsertedBy, speakersignId) => {
    let cancel
    let url = AoUrl.postspeakerupsertuser;
    let body = {}
    body['speakerUserId'] = speakerUserId
    body['userId'] = userId;
    body['speakerProfile'] = speakerProfile;
    body['videoLinkPath'] = videoLinkPath;
    body['speakerImageId'] = speakerImageId;
    body['remarks'] = remarks;
    body['isActive'] = isActive;
    body['upsertedBy'] = upsertedBy
    body['speakersignId'] = speakersignId
    return invoke(url, "POST", body, cancel)
  },

  getCitizenshipType: async () => {
    let cancel;
    let url = AoUrl.getCitizenshipTypePath;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  getAttorneyReportAsync: async (startDate, endDate, targetDate) => {
    let cancel;
    let url = `${AoUrl.getAttorneyReportAsync}?startDate=${startDate}&endDate=${endDate}&targetDate=${targetDate}`;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  getARDeptReportAsync: async (startDate, endDate, targetDate) => {
    let cancel;
    let url = `${AoUrl.getARDeptReportAsync}?startDate=${startDate}&endDate=${endDate}&targetDate=${targetDate}`;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  getcountrycode: async () => {
    let cancel;
    let url = AoUrl.getcountrycodepath
    let body = {}
    return invoke(url, "GET", body, cancel)
  },

  subtenantmemberbyuserid: async (jsondata) => {
    let cancel;
    let url = AoUrl.postsubtenantusermemberupdate;
    let body = jsondata;
    return invoke(url, "PUT", body, cancel)
  },

  addAddressByuserId: async (jsonAddress) => {
    let cancel;
    let url = AoUrl.postaddressbyuserid;
    let body = jsonAddress;
    return invoke(url, "POST", body, cancel)
  },

  postfileuploadspeaker: async (File, UploadedBy, UserId, FileTypeId, FileCategoryId, fileStatusId) => {
    let cancel;
    // let url = AoUrl.postfileuploadspeaker;
    let formdata = new FormData();
    formdata.append('file', File);
    formdata.append('uploadedBy', UploadedBy);
    formdata.append('userId', UserId);
    formdata.append('fileTypeId', FileTypeId)
    formdata.append('fileCategoryId', FileCategoryId);
    formdata.append('fileStatusId', fileStatusId)
    const url = BASE_URL_New + '/api/FileUpload/uploadUserDocuments'
    return invoke(url, "POST", formdata, cancel)
  },

  getSourceTypeService: async () => {
    let cancel;
    let url = AoUrl.sourceTypeapi;
    let body = [];
    return invoke(url, "GET", body, cancel);
  },

  getModuleConnectservice: async (id) => {
    let cancel;
    let url = AoUrl.getModuleConnecturl + '?MoConId=' + id;
    let body = {};
    return invoke(url, "GET", body, cancel);
  },

  upsertModuleConnectservice: async (json) => {
    let cancel;
    let url = AoUrl.getModuleConnecturl;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  postAddUserAuthSubsInsService: async (json) => {
    let cancel;
    let url = AoUrl.postAddUserAuthSubsInsurl;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  postcreaterequestService: async (json) => {
    let cancel;
    let url = AoUrl.postrefundrequest;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  getRefundrequestService: async (json) => {
    let cancel;
    let url = AoUrl.getRefundrequesturl;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  updateRefundrequestService: async (json) => {
    let cancel;
    let url = AoUrl.updateRefundrequesturl;
    let body = json;
    return invoke(url, "PUT", body, cancel);
  },

  updateOrderService: async (json) => {
    let cancel;
    let url = AoUrl.updateOrderurl;
    let body = json;
    return invoke(url, "PUT", body, cancel);
  },

  updateRefundPaymentService: async (json) => {
    let cancel;
    let url = AoUrl.updateRefundPaymenturl;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  updateTransferService: async (json) => {
    let cancel;
    let url = AoUrl.updateTransferPayment;
    let body = json;
    return invoke(url, "POST", body, cancel);
  },

  checkTransactionStatusrService: async (transactionId) => {
    let cancel;
    let url = AoUrl.checkTransactionStatusurl + '?transactionId=' + transactionId;
    let body = {};
    return invoke(url, "POST", body, cancel);
  },

  updateWithdrawnService: async (json) => {
    let cancel;
    let url = AoUrl.withdrawnAmounturl;
    let body = json;
    return invoke(url, "POST", body, cancel);
  }

};


let $postServiceFn = {

  postAddOther: function (method, arrayOfData, callback) {
    let url =
      (method == "POST")
        ? AoUrl.addOtherPath
        : method == "PUT"
          ? AoUrl.updateOtherPath
          : "";

    konsole.log("arryaofOther", arrayOfData, url);

    $CommonServiceFn.InvokeCommonApi(method, url, arrayOfData, (response, error) => {
      if (response) {
        callback(response);
      } else if (error) {
        callback(null, error);
      }
    })
  },

  postMapOther: function (method, arrayOfData, callback) {
    konsole.log("arryaofOther", arrayOfData);

    $CommonServiceFn.InvokeCommonApi(method, AoUrl.mapOtherwithFormPath, arrayOfData, (response, error) => {
      if (response) {
        callback(response);
      } else if (error) {
        callback(null, error);
      }
    })
  },

}


export { $CommonServiceFn, Services, $postServiceFn };